import View from './View';

export { default as View, getAudioSubtitleStyles } from './View';

export default View;
